'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _createForOfIteratorHelper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _toArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toArray");

var _awaitAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var isIpfs = require('is-ipfs');

var CID = require('cids');

var _require = require('buffer'),
    Buffer = _require.Buffer;

var TimeoutController = require('timeout-abort-controller');

var anySignal = require('any-signal');

var parseDuration = require('parse-duration');

var Key = require('interface-datastore').Key;

var _require2 = require('./errors'),
    TimeoutError = _require2.TimeoutError;

var ERR_BAD_PATH = 'ERR_BAD_PATH';
exports.OFFLINE_ERROR = 'This command must be run in online mode. Try running \'ipfs daemon\' first.';
exports.MFS_FILE_TYPES = {
  file: 0,
  directory: 1,
  'hamt-sharded-directory': 1
};
exports.MFS_ROOT_KEY = new Key('/local/filesroot');
exports.MFS_MAX_CHUNK_SIZE = 262144;
exports.MFS_MAX_LINKS = 174;
/**
 * Break an ipfs-path down into it's hash and an array of links.
 *
 * examples:
 *  b58Hash -> { hash: 'b58Hash', links: [] }
 *  b58Hash/mercury/venus -> { hash: 'b58Hash', links: ['mercury', 'venus']}
 *  /ipfs/b58Hash/links/by/name -> { hash: 'b58Hash', links: ['links', 'by', 'name'] }
 *
 * @param  {String} ipfsPath An ipfs-path
 * @return {Object}            { hash: base58 string, links: [string], ?err: Error }
 * @throws on an invalid @param ipfsPath
 */

function parseIpfsPath(ipfsPath) {
  ipfsPath = ipfsPath.replace(/^\/ipfs\//, '');
  var matched = ipfsPath.match(/([^/]+(?:\/[^/]+)*)\/?$/);

  if (!matched) {
    throw new Error('invalid ipfs ref path');
  }

  var _matched$1$split = matched[1].split('/'),
      _matched$1$split2 = _toArray(_matched$1$split),
      hash = _matched$1$split2[0],
      links = _matched$1$split2.slice(1); // check that a CID can be constructed with the hash


  if (isIpfs.cid(hash)) {
    return {
      hash: hash,
      links: links
    };
  } else {
    throw new Error('invalid ipfs ref path');
  }
}
/**
 * Returns a well-formed ipfs Path.
 * The returned path will always be prefixed with /ipfs/ or /ipns/.
 *
 * @param  {String} pathStr An ipfs-path, or ipns-path or a cid
 * @return {String} ipfs-path or ipns-path
 * @throws on an invalid @param ipfsPath
 */


var normalizePath = function normalizePath(pathStr) {
  if (isIpfs.cid(pathStr)) {
    return "/ipfs/".concat(new CID(pathStr));
  } else if (isIpfs.path(pathStr)) {
    return pathStr;
  } else {
    throw Object.assign(new Error("invalid path: ".concat(pathStr)), {
      code: ERR_BAD_PATH
    });
  }
}; // TODO: do we need both normalizePath and normalizeCidPath?


var normalizeCidPath = function normalizeCidPath(path) {
  if (Buffer.isBuffer(path)) {
    return new CID(path).toString();
  }

  if (CID.isCID(path)) {
    return path.toString();
  }

  if (path.indexOf('/ipfs/') === 0) {
    path = path.substring('/ipfs/'.length);
  }

  if (path.charAt(path.length - 1) === '/') {
    path = path.substring(0, path.length - 1);
  }

  return path;
};
/**
 * Resolve various styles of an ipfs-path to the hash of the target node.
 * Follows links in the path.
 *
 * Accepts formats:
 *  - <base58 string>
 *  - <base58 string>/link/to/venus
 *  - /ipfs/<base58 string>/link/to/pluto
 *  - multihash Buffer
 *  - Arrays of the above
 *
 * @param {Dag} dag The IPFS dag api
 * @param {Array<CID|string>} ipfsPaths A single or collection of ipfs-paths
 * @param {Object} [options] Optional options passed directly to dag.resolve
 * @return {Promise<Array<CID>>}
 */


var resolvePath = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dag, ipfsPaths, options) {
    var cids, _iterator2, _step2, path, _parseIpfsPath, hash, links, cid, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, _value2, value, linkName;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            options = options || {};

            if (!Array.isArray(ipfsPaths)) {
              ipfsPaths = [ipfsPaths];
            }

            cids = [];
            _iterator2 = _createForOfIteratorHelper(ipfsPaths);
            _context.prev = 4;

            _iterator2.s();

          case 6:
            if ((_step2 = _iterator2.n()).done) {
              _context.next = 59;
              break;
            }

            path = _step2.value;

            if (!isIpfs.cid(path)) {
              _context.next = 11;
              break;
            }

            cids.push(new CID(path));
            return _context.abrupt("continue", 57);

          case 11:
            _parseIpfsPath = parseIpfsPath(path), hash = _parseIpfsPath.hash, links = _parseIpfsPath.links;

            if (links.length) {
              _context.next = 15;
              break;
            }

            cids.push(new CID(hash));
            return _context.abrupt("continue", 57);

          case 15:
            cid = new CID(hash);
            _context.prev = 16;
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _context.prev = 19;
            _iterator = _asyncIterator(dag.resolve(path, options));

          case 21:
            _context.next = 23;
            return _iterator.next();

          case 23:
            _step = _context.sent;
            _iteratorNormalCompletion = _step.done;
            _context.next = 27;
            return _step.value;

          case 27:
            _value = _context.sent;

            if (_iteratorNormalCompletion) {
              _context.next = 34;
              break;
            }

            _value2 = _value, value = _value2.value;

            if (CID.isCID(value)) {
              cid = value;
            }

          case 31:
            _iteratorNormalCompletion = true;
            _context.next = 21;
            break;

          case 34:
            _context.next = 40;
            break;

          case 36:
            _context.prev = 36;
            _context.t0 = _context["catch"](19);
            _didIteratorError = true;
            _iteratorError = _context.t0;

          case 40:
            _context.prev = 40;
            _context.prev = 41;

            if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
              _context.next = 45;
              break;
            }

            _context.next = 45;
            return _iterator.return();

          case 45:
            _context.prev = 45;

            if (!_didIteratorError) {
              _context.next = 48;
              break;
            }

            throw _iteratorError;

          case 48:
            return _context.finish(45);

          case 49:
            return _context.finish(40);

          case 50:
            _context.next = 56;
            break;

          case 52:
            _context.prev = 52;
            _context.t1 = _context["catch"](16);

            // TODO: add error codes to IPLD
            if (_context.t1.message.startsWith('Object has no property')) {
              linkName = _context.t1.message.replace('Object has no property \'', '').slice(0, -1);
              _context.t1.message = "no link named \"".concat(linkName, "\" under ").concat(cid);
              _context.t1.code = 'ERR_NO_LINK';
            }

            throw _context.t1;

          case 56:
            cids.push(cid);

          case 57:
            _context.next = 6;
            break;

          case 59:
            _context.next = 64;
            break;

          case 61:
            _context.prev = 61;
            _context.t2 = _context["catch"](4);

            _iterator2.e(_context.t2);

          case 64:
            _context.prev = 64;

            _iterator2.f();

            return _context.finish(64);

          case 67:
            return _context.abrupt("return", cids);

          case 68:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 61, 64, 67], [16, 52], [19, 36, 40, 50], [41,, 45, 49]]);
  }));

  return function resolvePath(_x, _x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();

var mapFile = function mapFile(file, options) {
  options = options || {};
  var output = {
    cid: file.cid,
    path: file.path,
    name: file.name,
    depth: file.path.split('/').length,
    size: 0,
    type: 'dir'
  };

  if (file.unixfs) {
    if (file.unixfs.type === 'file') {
      output.size = file.unixfs.fileSize();
      output.type = 'file';

      if (options.includeContent) {
        output.content = file.content();
      }
    }

    output.mode = file.unixfs.mode;
    output.mtime = file.unixfs.mtime;
  }

  return output;
};

function withTimeoutOption(fn, optionsArgIndex) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var options = args[optionsArgIndex == null ? args.length - 1 : optionsArgIndex];
    if (!options || !options.timeout) return fn.apply(void 0, args);
    var timeout = typeof options.timeout === 'string' ? parseDuration(options.timeout) : options.timeout;
    var controller = new TimeoutController(timeout);
    options.signal = anySignal([options.signal, controller.signal]);
    var fnRes = fn.apply(void 0, args);
    var timeoutPromise = new Promise(function (resolve, reject) {
      controller.signal.addEventListener('abort', function () {
        reject(new TimeoutError());
      });
    });
    var start = Date.now();

    var maybeThrowTimeoutError = function maybeThrowTimeoutError() {
      if (controller.signal.aborted) {
        throw new TimeoutError();
      }

      var timeTaken = Date.now() - start; // if we have starved the event loop by adding microtasks, we could have
      // timed out already but the TimeoutController will never know because it's
      // setTimeout will not fire until we stop adding microtasks

      if (timeTaken > timeout) {
        controller.abort();
        throw new TimeoutError();
      }
    };

    if (fnRes[Symbol.asyncIterator]) {
      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var it, _yield$_awaitAsyncGen, value, done;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                it = fnRes[Symbol.asyncIterator]();
                _context2.prev = 1;

              case 2:
                if (!true) {
                  _context2.next = 15;
                  break;
                }

                _context2.next = 5;
                return _awaitAsyncGenerator(Promise.race([it.next(), timeoutPromise]));

              case 5:
                _yield$_awaitAsyncGen = _context2.sent;
                value = _yield$_awaitAsyncGen.value;
                done = _yield$_awaitAsyncGen.done;

                if (!done) {
                  _context2.next = 10;
                  break;
                }

                return _context2.abrupt("break", 15);

              case 10:
                maybeThrowTimeoutError();
                _context2.next = 13;
                return value;

              case 13:
                _context2.next = 2;
                break;

              case 15:
                _context2.next = 21;
                break;

              case 17:
                _context2.prev = 17;
                _context2.t0 = _context2["catch"](1);
                maybeThrowTimeoutError();
                throw _context2.t0;

              case 21:
                _context2.prev = 21;
                controller.clear();

                if (it.return) {
                  it.return();
                }

                return _context2.finish(21);

              case 25:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[1, 17, 21, 25]]);
      }))();
    }

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var res;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return Promise.race([fnRes, timeoutPromise]);

            case 3:
              res = _context3.sent;
              maybeThrowTimeoutError();
              return _context3.abrupt("return", res);

            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](0);
              maybeThrowTimeoutError();
              throw _context3.t0;

            case 12:
              _context3.prev = 12;
              controller.clear();
              return _context3.finish(12);

            case 15:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 8, 12, 15]]);
    }))();
  };
}

exports.normalizePath = normalizePath;
exports.normalizeCidPath = normalizeCidPath;
exports.parseIpfsPath = parseIpfsPath;
exports.resolvePath = resolvePath;
exports.mapFile = mapFile;
exports.withTimeoutOption = withTimeoutOption;